/* eslint-disable func-names */
/* eslint-disable no-underscore-dangle */
import React, { useEffect } from 'react';
import pendoService from './pendoService';

const Pendo = () => {
  useEffect(() => {
    pendoService.install();
  });
  return <></>;
};

export default Pendo;
